import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { Observable } from 'rxjs';
import { CustomerSurveyQuestionConfiguration } from '../models/customer-survey-question-configuration.model';
import { CustomerSurveyConfiguration } from '../models/customer-survey-configuration.model';

@Injectable()
export class CustomerSurveyService extends BaseApiService {

    saveSurveyConfiguration(customerSurveyConfiguration: CustomerSurveyConfiguration): Observable<CustomerSurveyConfiguration> {
        return this.post(`Customer/Survey/Configuration/${customerSurveyConfiguration.clientFlowType.id}`, customerSurveyConfiguration);
    }

    getSurveyConfiguration(clientFlowTypeId: number): Observable<CustomerSurveyConfiguration> {
        return this.get(`Customer/Survey/Configuration/${clientFlowTypeId}`);
    }

    getAllSurveyConfigurations(): Observable<{ result: CustomerSurveyConfiguration[] }> {
        return this.get('Customer/Survey/Configuration');
    }

    saveQuestions(clientFlowTypeId: number, questions: CustomerSurveyQuestionConfiguration[]): Observable<{ result: CustomerSurveyQuestionConfiguration[] }> {
        return this.post(`Customer/Survey/Configuration/${clientFlowTypeId}/Questions`, questions);
    }

    getQuestions(clientFlowTypeId: number): Observable<{ result: CustomerSurveyQuestionConfiguration[] }> {
        return this.get(`Customer/Survey/Configuration/${clientFlowTypeId}/Questions`);
    }

    sendCustomerSurvey(customerNumberId: number, customerContactId: number, languageCode: string): Observable<void> {
        return this.post('Customer/Survey/Send', {
            customerNumberId,
            customerContactId,
            languageCode
        });
    }
}
